import { useEffect, useState, useRef } from 'react';
import Navbar from '../Components/NavBarAirbnbStyle';
import Lateral1 from '../images/lateral1.png';
import Lateral2 from '../images/lateral2.png';
import { db, storage, auth } from '../Firebase/Firebase';
import { getDocs, collection, setDoc, doc, query, where, updateDoc, deleteDoc, getDoc } from 'firebase/firestore';
import './spaceDetails.css'
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { listAll } from 'firebase/storage';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NavbarMobileVersion from '../Components/NavBar/NavBarMobileVersion';

const SpaceDetails = () => {
    const [accesorios, setAccesorios] = useState("");
    const [capacidadMax, setCapacidadMax] = useState("");
    const [capacidadMin, setCapacidadMin] = useState("");
    const [color, setColor] = useState("#fcbf49");
    const [descripcionEspacio, setDescripcionEspacio] = useState("");
    const [idLugar, setIdLugar] = useState("");
    const [nombreEspacio, setNombreEspacio] = useState("");
    const [tipoEspacio, setTipoEspacio] = useState("");
    const [idTipoEspacio, setIdTipoEspacio] = useState('');
    const [descripcionTipo, setDescripcionTipo] = useState('');
    const [tiposEspacio, setTiposEspacio] = useState([]);
    const [espacios, setEspacios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [logo, setlogo] = useState(null);
    const fetchEspacios = async () => {
        if (idLugar) {
            const espaciosCollection = collection(db, 'espacios');
            const q = query(espaciosCollection, where('IdLugar', '==', idLugar));
            const querySnapshot = await getDocs(q);

            const espaciosData = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));
            setEspacios(espaciosData);
            console.log("Espacios después de la consulta:", espaciosData); // Cambiado a 'espaciosData'

        }
        setLoading(false);
    };
    useEffect(() => {
        fetchEspacios();
    }, [idLugar]);
    const fetchTiposEspacio = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, 'tipoespacio'));
            const tipos = [];
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                tipos.push({
                    id: doc.id, // Usamos el ID del documento
                    tipoEspacio: data.TipoEspacio,
                    descripcionEspacio: data.DescripcionEspacio
                });
            });
            setTiposEspacio(tipos);
        } catch (error) {
            console.error("Error al obtener los tipos de espacio:", error);
        }
    };
    useEffect(() => {
        fetchTiposEspacio();
    }, []);
    const generateRandomId = () => {
        return 'espacio_' + Math.random().toString(36).substr(2, 9);
    };

    const [imagenesEspacio, setImagenesEspacio] = useState([]);
    const handleDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        agregarImagenes(files);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const agregarImagenes = (nuevas) => {
        const unicas = nuevas.filter(
            (file) => !imagenesEspacio.some(img => img.name === file.name && img.size === file.size)
        );
        setImagenesEspacio(prev => [...prev, ...unicas]);
    };

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        agregarImagenes(files);
    };

    const eliminarImagen = (index) => {
        const nuevas = [...imagenesEspacio];
        nuevas.splice(index, 1);
        setImagenesEspacio(nuevas);
    };



    const imageInputRef = useRef(null); // Referencia para el campo de imágenes
    const iconInputRef = useRef(null);  // Referencia para el campo de ícono

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!idLugar) {
            toast.error("El id del Lugar no está disponible. Asegúrate de que está almacenado correctamente.");
            return;
        }
        if (!idTipoEspacio) {
            toast.error("Por favor selecciona un tipo de espacio.");
            return;
        }
        const newIdEspacio = generateRandomId();
        const imageUrls = [];  // Lista para almacenar los URLs de las imágenes
        let logoUrl = null;
        try {
            // Subir cada imagen a Firebase Storage
            for (let i = 0; i < imagenesEspacio.length; i++) {
                const imagen = imagenesEspacio[i];
                const imageName = `${newIdEspacio}${i + 1}.png`;
                const storageRef = ref(storage, `FotosEspacio/${newIdEspacio}/${imageName}`);
                const snapshot = await uploadBytes(storageRef, imagen);
                const downloadURL = await getDownloadURL(snapshot.ref);
                imageUrls.push(downloadURL);
            }

            const newData = {
                IdEspacio: newIdEspacio,
                Accesorios: accesorios,
                CapacidadMax: Number(capacidadMax),
                CapacidadMin: Number(capacidadMin),
                Color: color,
                DescripcionEspacio: descripcionEspacio,
                IdLugar: idLugar,
                NombreEspacio: nombreEspacio,
                TipoEspacio: idTipoEspacio,
                Imagenes: imageUrls,
                logo: logoUrl
            };

            // Registrar el espacio en Firestore
            await setDoc(doc(db, "espacios", newIdEspacio), newData);
            fetchEspacios();

            limpiarCamposFormulario();
            // Reinicia el valor de los campos de archivo después de registrar
            if (imageInputRef.current) imageInputRef.current.value = "";
            if (iconInputRef.current) iconInputRef.current.value = "";
            toast.success("Registro Exitoso");

        } catch (error) {
            console.error("Error al registrar el espacio: ", error);
            toast.error("Error al registrar el espacio. Por favor intenta de nuevo.");
        }
    };
    // Función para manejar el cambio de selección del tipo de espacio
    const handleTipoEspacioChange = (e) => {
        const selectedTipoEspacio = e.target.value;
        setTipoEspacio(selectedTipoEspacio);

        // Encontrar el tipo de espacio seleccionado y obtener su id y descripción
        const selectedEspacio = tiposEspacio.find(tipo => tipo.tipoEspacio === selectedTipoEspacio);
        if (selectedEspacio) {
            setIdTipoEspacio(selectedEspacio.id);  // Guardar el idTipoEspacio
            setDescripcionTipo(selectedEspacio.descripcionEspacio);  // Mostrar la descripción del espacio
        } else {
            setIdTipoEspacio('');
            setDescripcionTipo('');
        }
    };

    const limpiarCamposFormulario = () => {
        setAccesorios('');
        setCapacidadMax('');
        setCapacidadMin('');
        setColor('');
        setDescripcionEspacio('');
        setNombreEspacio('');
        setTipoEspacio('');
        setIdTipoEspacio('');
        setDescripcionTipo('');
        setImagenesEspacio([]);
        setlogo(null);
    };


    const uploadImages = async (images, existingIdEspacio) => {
        const urls = [];

        for (let i = 0; i < images.length; i++) {
            const imagen = images[i];
            const imageName = `${existingIdEspacio}${i + 1}`; // Usa el Id existente para nombrar la imagen

            // Ruta de almacenamiento: FotosEspacio/{existingIdEspacio}/Id{i+1}
            const storageRef = ref(storage, `FotosEspacio/${existingIdEspacio}/${imageName}`);
            const snapshot = await uploadBytes(storageRef, imagen);
            const downloadURL = await getDownloadURL(snapshot.ref);
            urls.push(downloadURL);  // Agregar cada URL a la lista
        }

        return urls; // Devuelve las URLs de las imágenes subidas
    };
 const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      // Intentamos leer valor guardado en localStorage
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
      }
    } catch (error) {
      // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
      console.warn('Error leyendo localStorage darkMode:', error);
    }

    // Detectar modo oscuro sistema solo si está disponible window.matchMedia
    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

    // Detectar hora nocturna (7pm a 6am)
    const hour = new Date().getHours();
    const isNight = hour >= 19 || hour < 6;

    // Retorna true o false seguro
    return prefersDark || isNight;
  });

  // Cargar el tema al inicio (localStorage, sistema u hora)
  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme !== null) {
      setIsDarkMode(JSON.parse(savedTheme));
    } else {
      // Detecta modo oscuro sistema
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

      // Detecta modo oscuro por hora (7pm - 6am)
      const hour = new Date().getHours();
      const isNight = hour >= 19 || hour < 6;

      setIsDarkMode(prefersDark || isNight);
    }
  }, []);

  // Guardar la preferencia y aplicar clase al body
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  // Función para cambiar el modo
  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);

    return (
        <div>
            <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
            <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
            <ToastContainer />
            <div className='center-header-space'>
                <img className='imagenlateral1' src={Lateral1} alt="Lateral" />
                <div className="Presentation">
                    <div className="form-container-space">
                        <form onSubmit={handleSubmit}>
                            <div className="form-column">
                                <p>Nombre del Espacio:</p>
                                <input
                                    type="text"
                                    value={nombreEspacio}
                                    onChange={(e) => setNombreEspacio(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-column">
                                <p>Descripción del Espacio:</p>
                                <textarea
                                    value={descripcionEspacio}
                                    onChange={(e) => setDescripcionEspacio(e.target.value)}
                                    required
                                ></textarea>
                            </div>
                            <div className="form-column">
                                <p>Tipo de Espacio:</p>
                                <select
                                    value={tipoEspacio}
                                    onChange={handleTipoEspacioChange}
                                    required
                                >
                                    <option value="">Selecciona un tipo de espacio</option>
                                    {tiposEspacio.map((tipo) => (
                                        <option key={tipo.id} value={tipo.tipoEspacio}>
                                            {tipo.tipoEspacio}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-column">
                                <p>Capacidad Mínima:</p>
                                <input
                                    type="number"
                                    value={capacidadMin}
                                    onChange={(e) => setCapacidadMin(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-column">
                                <p>Capacidad Máxima:</p>
                                <input
                                    type="number"
                                    value={capacidadMax}
                                    onChange={(e) => setCapacidadMax(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-column">
                                <p>Accesorios:</p>
                                <textarea
                                    type="text"
                                    value={accesorios}
                                    onChange={(e) => setAccesorios(e.target.value)}
                                    required
                                ></textarea>
                            </div>
                            <div className="form-column">
                                <p>Color:</p>
                                <input
                                    type="color"
                                    value={color}
                                    onChange={(e) => setColor(e.target.value)}
                                    required
                                    style={{ backgroundColor: color }}  // Cambia el fondo al color seleccionado
                                />
                            </div>
                            <div className="form-column">
                                <p>Imágenes del espacio:</p>
                                <div
                                    className="drop-zone"
                                    onDrop={handleDrop}
                                    onDragOver={handleDragOver}
                                >
                                    <p>Arrastra y suelta imágenes aquí o haz clic para subir</p>
                                    <input
                                        type="file"
                                        multiple
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        ref={imageInputRef}
                                    />
                                </div>
                                {imagenesEspacio.length > 0 && (
                                    <div className="image-preview-grid">
                                        {imagenesEspacio.map((img, index) => (
                                            <div key={index} className="preview-item">
                                                <img src={URL.createObjectURL(img)} alt={`img-${index}`} />
                                                <button onClick={() => eliminarImagen(index)} className="delete-btn">✕</button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <button className='btn-space-details' type="submit">Registrar Espacio</button>
                        </form>
                    </div>
                </div>
                <img className='imagenlateral2' src={Lateral2} alt="Lateral" />
            </div>
            <div>
            </div>
        </div>
    );
};

export default SpaceDetails;
